 
import {
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../../../../../components/formsComponents";
import { useDispatchWrapper, useFetchPolicies } from "../../../../../../hooks";
import { useNavigate } from "react-router-dom";
import { Dialog } from "../../../../../../components/Dialogs/Dialog";
import { ICommAutomobileQuickAplication } from "../../../../../../redux/commAutoPolicy/commAutoAllApplications/commAutoAllApplications.types";
import { useCommAutoPolicyDriverInfo } from "../hooks/useCommAutoPolicyDriverInfo";
import { useCommAutoVehcileInfo } from "../hooks/useCommAutovehicleInfo";
import { addCommAutomobileQuickApllication } from "../../../../../../redux/commAutoPolicy/commAutoAllApplications/commAutoAllApplicationsActions";

export interface ICommAutomobileQuickApplicationProps {
  open: boolean;
  customerPolicyId: number;
  customerId: number;
  /**
   * Feature: lead-commercial-auto-risk-profile
   *
   * Optional lead key. When present (lead scope), Quick Create persists the
   * application scoped to this `lead_id` instead of `customer_policy_id`; the
   * thunk swaps the scope key via `buildBodyKey`. Absent this prop the dialog
   * behaves exactly as before (customer-policy scope), keyed by
   * `customer_policy_id` (Requirements 11.4, 16.1, 16.4).
   */
  leadId?: string;
  type: string;
  data: ICommAutomobileQuickAplication;
  onComplete: () => void;
  onClose: () => void;
}
export const QuickApplicationDialog: React.FC<
  ICommAutomobileQuickApplicationProps
> = (props) => {
  const {
	open,
	data,
	customerPolicyId,
	customerId,
	leadId,
	type,
	onClose,
	onComplete,
  } = props;
  const { policies } = useFetchPolicies();
  const dispatch = useDispatchWrapper();
  const [loading, setLoading] = React.useState(false);

  const { driverDropDown } = useCommAutoPolicyDriverInfo(customerPolicyId);
  const { vehcileDropdown } = useCommAutoVehcileInfo(customerPolicyId);

  const navigate = useNavigate();
  const {
	values,
	handleChange,
	handleSubmit,
	setValues,
	setFieldValue,
	errors,
  } = useFormik({
	initialValues: data,
	validate: (values) => {},
	onSubmit: async (values) => {
	  // Lead scope: gate on a non-empty lead key; the thunk swaps the scope key
	  // (lead_id, customer_policy_id omitted) via buildBodyKey. Customer-policy
	  // scope: gate on customerId + customerPolicyId exactly as before.
	  const hasLeadScope = typeof leadId === "string" && leadId.trim().length > 0;
	  if ((customerId && customerPolicyId) || hasLeadScope) {
		setLoading(true);
		dispatch(
		  addCommAutomobileQuickApllication(
			{
			  ...values,
			  customer_policy_id: customerPolicyId,
			  customer_id: customerId,
			  type: type,
			},
			(isSuccess) => {
			  if (isSuccess) {
				onComplete();
			  }
			  setLoading(false);
			},
			hasLeadScope ? leadId : undefined
		  )
		);
	  }
	},
  });

  return (
	<>
	  <Dialog
		open={open}
		title="Create Quick Application"
		onClose={onClose}
		size={"md"}
		contentWrappedWithForm={{ onSubmit: handleSubmit }}
		actions={[
		  {
			type: "submit",
			label: "Save & Close",
			variant: "contained",
			disabled: loading,
		  },
		]}
	  >
		<form onSubmit={handleSubmit}>
		  <Grid container spacing={1}>
			<Grid item xs={12} lg={6}>
			  <CustomFormLabel>Select Drivers</CustomFormLabel>
			  <ControlledCustomSelect
				variant="outlined"
				size="small"
				type="number"
				name="driver_incremental_number"
				value={values.driver_incremental_number || []}
				onChange={(e) => {
				  setFieldValue("driver_incremental_number", e.target.value);
				}}
				displayEmpty
				multiple
				fullWidth
				placeholder="Select one"
				options={driverDropDown}
			  />
			</Grid>
			<Grid item xs={12} lg={6}>
			  <CustomFormLabel>Select Vehicles</CustomFormLabel>
			  <ControlledCustomSelect
				variant="outlined"
				size="small"
				type="number"
				name="vehicle_incremental_number.vehicle_one"
				value={values.vehicle_incremental_number || []}
				onChange={(e) => {
				  setFieldValue("vehicle_incremental_number", e.target.value);
				}}
				displayEmpty
				multiple
				fullWidth
				placeholder="Select one"
				options={vehcileDropdown}
			  />
			</Grid>
		  </Grid>
		</form>
	  </Dialog>
	</>
  );
};

{
  /* {[0, 1, 2, 3].map((index) => {
			  // Get all selected values except current index AND skip empty strings
			  const selectedDrivers = values.driver_incremental_number.filter(
				(val, i) => i !== index && val !== ""
			  );

			  const filteredOptions = driverDropDown.filter(
				(option: { label: string; value: string }) =>
				  !selectedDrivers.includes(option.value)
			  );

			  // Get the current selected value (must match option object)
			  const selectedValue =
				driverDropDown.find(
				  (option) =>
					option.value === values.driver_incremental_number[index]
				) || null;

			  return (
				<Grid item xs={12} lg={3} key={`driver-${index}`}>
				  <CustomFormLabel>{`Driver ${index + 1}`}</CustomFormLabel>
				  <Autocomplete
					value={selectedValue}
					options={filteredOptions}
					getOptionLabel={(option) => option.label}
					onChange={(_, newValue) => {
					  const updated = [...values.driver_incremental_number];
					  updated[index] = newValue ? newValue.value : ""; // "" if cleared
					  setFieldValue("driver_incremental_number", updated);
					}}
					isOptionEqualToValue={(option, value) =>
					  option.value === value.value
					}
					renderInput={(params) => (
					  <CustomTextField {...params}  />
					)}
					clearOnEscape
					disableClearable={false}
				  />
				</Grid>
			  );
			})} */
}
